<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :setLoading="setLoading"
    :localDataGrid="true"
    :refreshDataGridProp="refreshDataGrid"
    :backButtonRoute="backButtonRoute"
    ref="goods-in"
    :data-model="dataModel"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
    :refreshColumns="refreshColumns"
    :getHeaderToolbar="getHeaderToolbar"
    :headerScreenJson="getHeaderScreenJson"
    :addSalesOrderItem="addGoodsInItem"
    :editProductItem="editGoodsInItem"
    :paging="false"
    class="goods-in"
  >
    <dx-tooltip :ref="tooltipRefName" position="top">
      <div class="tooltipContent">
        <div>Select to Include Lines in Goods In</div>
      </div>
    </dx-tooltip>

    <dx-tooltip :ref="CompleteTooltipRefName" position="top">
      <div class="tooltipContent">
        <div>Select to Mark Lines Complete</div>
      </div>
    </dx-tooltip>
  </TransactionTemplate>
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { formatNumber } from "devextreme/localization";
import { alert } from "devextreme/ui/dialog";
import { GoodsInService } from "../../_services/api/purchasing/goods-in.service";
import { GoodsInListService } from "../../_services/api/purchasing/goods-in-list.service";
import { FeatureStorage } from "../../_services/storage";
import DxTooltip from "devextreme-vue/tooltip";
import { on } from "devextreme/events";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { SupplierService } from "../../_services/api/suppliers/supplier.service";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
    DxTooltip,
  },
  data() {
    return {
      tooltipRefName: "tooltip",
      CompleteTooltipRefName: "completeTooltip",
      CheckStockWriteOff: false,
      loaded: false,
      setLoading: false,
      headerEndpoint: undefined,
      dataModel: {
        DateIn: new Date(),
        DateReceived: new Date(),
        SupplierCurrencyCode: "FX",
      },
      reload: false,
      validationSummary: [],
      ui: {
        DateInMin: null,
        DateInMax: null,
      },
      purchaseOrderDetail: {},
      serverError: {},
      refreshDataGrid: false,
      refreshColumns: undefined,
      addGoodsInItem: undefined,
      editGoodsInItem: undefined,
      expandChildGrid: false,
      gridDataLoaded: false,
      CollapseBtnContentReady: false,
      BatchGridInstance: undefined,
      headerToolBarForm: undefined,
      IsBatchAvailable: false,
      tabInToComment: false,
    };
  },

  async created() {
    this.dataModel.SalesOrderCode = this.baseView.id;
    // this.dataModel.SalesOrderSupplierName = this.baseView.SupplierName;
    await this.setActiveAccountingPeriod();
    let response = await GoodsInListService.getPurchaseOrderByCode(
      parseInt(this.baseView.id)
    );

    let purchaseOrderDetails = await GoodsInService.getPurchaseOrderByCode(
      parseInt(this.baseView.id)
    );

    this.purchaseOrderDetail = {
      ...purchaseOrderDetails.data.value[0],
    };

    this.dataModel.SupplierName = response.data.value[0].SupplierName;
    this.dataModel.SupplierCode = response.data.value[0].SupplierCode;
    this.dataModel.ComputedCode = response.data.value[0].ComputedCode;
    this.dataModel.DateChanged = response.data.value[0].DateChanged;

    await SupplierService.getByCode(this.dataModel.SupplierCode, {
      select: "CurrencyCode,Code",
    }).then((res) => {
      if (res.data.value.length > 0) {
        this.dataModel.SupplierCurrencyCode = res.data.value[0].CurrencyCode;
      }
    });

    this.initialized();
  },
  async mounted() {},
  beforeDestroy() {},

  computed: {
    backButtonRoute() {
      return "/goods-in";
    },
    getHeaderToolbar() {
      return {
        headerToolbar: {
          toolbarFormItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  dataField: "DateIn",
                  label: {
                    text: "Date",
                  },
                  editorType: "dxDateBox",
                  editorOptions: {
                    displayFormat: "dd MMM yyyy",
                    width: 120,
                    min: this.ui.DateInMin,
                    max: this.ui.DateInMax,
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                  },
                  validationRules: [
                    {
                      type: "required",
                      message: "Date is required",
                    },
                  ],
                },
                {
                  dataField: "DateReceived",
                  label: "Date Received",
                  editorType: "dxDateBox",
                  editorOptions: {
                    displayFormat: "dd MMM yyyy",
                    width: 120,
                    onKeyDown: (e) => {
                      this.onDateReceivedKeyDown(e);
                    },
                  },
                  validationRules: [
                    {
                      type: "required",
                      message: "Date Received is required",
                    },
                  ],
                },
              ],
            },
          ],
          save: true,
          saveCallback: this.saveGoodsIn,
          formContentReady: this.formContentReady,
        },
      };
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          title: {
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: undefined,
                text: "Create Goods In for PO # " + this.baseView.id,
              },
              secondary: {
                dataField: undefined,
                text: undefined,
              },
            },
            secondary: {
              dataField: "SupplierName",
              text: undefined,
            },
          },
        },
      };
    },
    getScreenJson() {
      var screenJson = {
        title: "Goods In",
        endpoint: {},
        headerData: {
          headerFormVisible: false,
          headerToolbar: {
            audit: false,
            status: false,
            notes: false,
          },
          title: {
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: undefined,
                text: "Create Goods In for PO # " + this.baseView.id,
              },
              secondary: {
                dataField: undefined,
                text: undefined,
              },
            },
            secondary: {
              dataField: "SupplierName",
              text: undefined,
            },
          },
        },
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "PurchaseOrderDetail",
              filter: [
                ["PurchaseOrderCode eq " + this.baseView.id],
                "and",
                ["LineStatus", "=", "A"],
              ],
              serverPaging: true,
              allowGrouping: false,
              postProcessCallback: this.PostProcess,
            },
            options: {
              onCellPreparedCallBack: this.onCellPreparedCallBack,
              dxPaging: false,
              onContentReadyCallBack: this.onContentReadyCallBack,
              // keyboardNavigation: {
              //   enabled: true,
              //   key: "ID",
              // },
              onEditorPreparing: this.onEditorPreparing,
            },
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
            review: false,
            save: false,
            expandMasterDetails: true,
            customButtons: [
              {
                icon: "plus",
                label: "Add Item",
                visible: FeatureStorage.checkPermission(
                  "GoodsInEditPrice",
                  "edit"
                ),
                clickAction: () => {
                  this.enableAddGoodsInOrderItem();
                },
                buttonLocation: "left",
              },
              {
                icon: this.expandChildGrid ? "chevronup" : "chevrondown",
                label: this.getLabel,
                clickAction: () => {
                  this.expandMasterDetailsSection();
                },
                buttonLocation: "left",
                ref: "toolbar-expand-btn",
                onContentReady: this.onCollapseBtnContentReady,
                visible: this.IsBatchAvailable,
              },
            ],
          },

          childColumns: this.getChildColumns,
          columns: [
            {
              screenField: "CheckInclude",
              allowEditing: false,
              defaultValue: false,
              valueChangeCallBack: this.checkBoxValueChange,
              allowHiding: false,
              showInColumnChooser: false,
              fixed: true,
              fixedPosition: "left",
              label: "",
              width: ColumnWidth.CheckBoxColumn.width,
              minWidth: ColumnWidth.CheckBoxColumn.minWidth,
            },

            {
              screenField: "ProductItem",
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              label: "Product / Account",
              width: "auto",
              sortOrder: "asc",
              sortIndex: 0,
            },
            {
              screenField: "Branch",
              cellTemplate: undefined,
              gridDataField: "BranchCode",
              width: ColumnWidth.BranchCode.width,
              minWidth: ColumnWidth.BranchCode.minWidth,
            },
            {
              screenField: "Division",
              cellTemplate: undefined,
              gridDataField: "DivisionCode",
              width: ColumnWidth.Division.width,
              minWidth: ColumnWidth.Division.minWidth,
            },
            {
              screenField: "SalesUM",
              dataField: "SupplierUM",
              width: ColumnWidth.UnitOfMeasure.width,
              minWidth: ColumnWidth.UnitOfMeasure.minWidth,
            },
            {
              // screenField: "Tax",
              gridLabel: "Tax",
              dataField: "TaxCode",
              width: ColumnWidth.TaxCode.width,
              minWidth: ColumnWidth.TaxCode.minWidth,
            },
            {
              screenField: "SalesUMFXPrice",
              label: `Unit Price (${this.dataModel.SupplierCurrencyCode})`,
              gridDataField: "SupplierFXPrice",
              format: "Decimal-16-4C",
              allowEditing: false,
              width: ColumnWidth.Price4DecimalPoints.width,
              minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
            },
            {
              screenField: "Ordered",
              dataField: "SupplierRequired",
              width: ColumnWidth.Quantity2DecimalPoints.width,
              maxWidth: ColumnWidth.Quantity2DecimalPoints.maxWidth,
              label: "Ordered",
            },

            {
              screenField: "Quantity",
              dataField: "SupplierOutstandingQuantity",
              format: "Decimal-16-2",
              label: "Outstanding",
              width: ColumnWidth.Quantity2DecimalPoints.width,
              maxWidth: ColumnWidth.Quantity2DecimalPoints.maxWidth,
            },
            {
              screenField: "Quantity",
              dataField: "SupplierReceivedQty",
              format: "Decimal-16-2",
              label: "Received",
              type: "EditableDecimal",
              allowEditing: true,
              showEditorAlways: true,
              makeDisabled: (data) => {
                if (data.data.IsBatchProduct == "No") {
                  return false;
                } else return true;
              },
              width: ColumnWidth.Quantity2DecimalPoints.width,
              maxWidth: ColumnWidth.Quantity2DecimalPoints.maxWidth,
              onKeyDown: (e, cellInfo) => {
                this.onSupplierReceivedQtyKeyDown(e, cellInfo);
              },
            },
            {
              screenField: "FXLineTotal",
              gridLabel: `Ex Total (${this.dataModel.SupplierCurrencyCode})`,
              gridDataField: "ExFXTotal",
              format: "Decimal-16-2C",
              width: ColumnWidth.Price2DecimalPoints.width,
              maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
              visible: false,
            },
            {
              screenField: "TaxFXTotal",
              gridLabel: `Tax (${this.dataModel.SupplierCurrencyCode})`,
              format: "Decimal-16-2C",
              width: ColumnWidth.Price2DecimalPoints.width,
              maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
              visible: false,
            },
            {
              screenField: "IncTaxFXTotal",
              gridLabel: `Inc Total (${this.dataModel.SupplierCurrencyCode})`,
              format: "Decimal-16-2C",
              width: ColumnWidth.Price2DecimalPoints.width,
              maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
              visible: false,
            },

            {
              screenField: "Comments",
              dataField: "Comment",
              width: 400,
              minWidth: 400,
              cellTemplate: "ScrollView",
              cssClass: "grid-text-scroll",
              label: "PO Comments",
              allowEditing: false,
              visible: false,
            },
            {
              dataField: "GoodsInDetailComment",
              screenField: "Comments",
              width: 400,
              minWidth: 400,
              cellTemplate: "ScrollView",
              cssClass: "edit-cell-textbox-field",
              label: "Goods In Comment",
              allowEditing: true,
              showEditorAlways: true,
              editorOptions: {
                onKeyDown: (e, cellInfo) => {
                  this.onGoodsInDetailCommentKeyDown(e, cellInfo);
                },
                // onFocusOut: this.onGoodsInDetailCommentFocusOut,
              },
            },
            {
              screenField: "IsDefault",
              gridDataField: "Completed",
              label: "",
              cellTemplate: "CheckBoxTemplate",
              width: ColumnWidth.CheckBoxColumn.width,
              minWidth: ColumnWidth.CheckBoxColumn.minWidth,
              cssClass: "column-checkBox",
              allowSorting: false,
              allowSearch: false,
              makeReadOnly: (e) => {
                let data = e.data;
                if (e.rowType == "header") {
                  // return this.checkCompleteHeaderCheckStatus(e);
                } else {
                  if (data && data.CheckInclude == false) {
                    return true;
                  } else if (data.RequiredQty < 0) {
                    if (
                      data.SupplierReceivedQty <=
                      data.SupplierOutstandingQuantity
                    )
                      return true;
                    else return false;
                  } else if (
                    data &&
                    data.SupplierReceivedQty >= data.SupplierOutstandingQuantity
                  ) {
                    // this.disableCompleteHeader(true);
                    return true;
                  } else if (
                    data &&
                    data.SupplierReceivedQty < data.SupplierOutstandingQuantity
                  ) {
                    return false;
                  } else return false;
                }
              },
              headerCellTemplate: "HeaderCheckBoxTemplate",
              defaultValue: false,
              fixed: true,
              fixedPosition: "right",
            },
            {
              screenField: "GridRecordEllipsisMenu",
              allowEditing: false,
              showInColumnChooser: false,
              allowSorting: false,
              allowSearch: false,
              cssClass: "padding-7",
              visible: FeatureStorage.checkPermission(
                "GoodsInEditPrice",
                "edit"
              ),
              ellipsisMenu: {
                itemAction: () => {
                  var items = [
                    {
                      menuText: "Edit Item",
                      clickAction: this.enableEditGoodsInItem,
                      visible: FeatureStorage.checkPermission(
                        "GoodsInEditPrice",
                        "edit"
                      ),
                    },
                  ];
                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
            },
          ],

          valueChangedEventListners: [
            {
              dataField: "SupplierReceivedQty",
              listner: (e, lineData) => {
                this.onRequiredQtyValidations(e, lineData);
              },
            },
            {
              dataField: "SupplierBatchReceivedQty",
              listner: (e, lineData, items, grid, lineParent) => {
                this.onSupplierBatchReceivedQtyChange(
                  e,
                  lineData,
                  items,
                  grid,
                  lineParent
                );
              },
            },

            {
              dataField: "BatchNo",
              listner: (e, lineData, lineParent) => {
                lineData.data.BatchNo = e.value;

                this.onBatchNoUpdate(e, lineData, lineParent);
              },
            },
            {
              dataField: "SupplierBatchNo",
              listner: (e, lineData) => {
                lineData.data.SupplierBatchNo = e.value;
              },
            },
            {
              dataField: "ManufacturedDate",
              listner: (e, lineData) => {
                lineData.data.ManufacturedDate = e.value;

                if (e.value) {
                  if (
                    lineData.data.UseByShelfLife > -1 &&
                    lineData.data.BestBeforeShelfLife > -1
                  ) {
                    lineData.data.UseByDate = new Date(e.value).addDays(
                      lineData.data.UseByShelfLife
                    );
                  } else if (
                    lineData.data.UseByShelfLife > -1
                    // && item.BestBeforeShelfLife != -1
                  ) {
                    lineData.data.UseByDate = new Date(e.value).addDays(
                      lineData.data.UseByShelfLife
                    );
                  } else if (
                    lineData.data.BestBeforeShelfLife > -1
                    // && item.UseByShelfLife != -1
                  ) {
                    lineData.data.BestBeforeDate = new Date(e.value).addDays(
                      lineData.data.BestBeforeShelfLife
                    );
                  } else {
                    lineData.data.UseByDate = undefined;
                    lineData.data.BestBeforeDate = undefined;
                  }
                } else {
                  lineData.data.UseByDate = undefined;
                  lineData.data.BestBeforeDate = undefined;
                }
              },
            },
            {
              dataField: "BestBeforeDate",
              listner: (e, lineData) => {
                lineData.data.BestBeforeDate = e.value;
                if (
                  new Date(e.value) < new Date(lineData.data.ManufacturedDate)
                ) {
                  this.$alert(
                    "Best Before Date can not be less than the Manufactured Date",
                    "Validation Error"
                  );
                  lineData.data.BestBeforeDate = e.previousValue;
                }
              },
            },
            {
              dataField: "UseByDate",
              listner: (e, lineData) => {
                lineData.data.UseByDate = e.value;
                if (
                  new Date(e.value) < new Date(lineData.data.ManufacturedDate)
                ) {
                  this.$alert(
                    "Use By Date can not be less than the Manufactured Date",
                    "Validation Error"
                  );
                  lineData.data.UseByDate = e.previousValue;
                }
              },
            },
            {
              dataField: "SupplierBatchReceivedQty",
              listner: (e, lineData, items, grid, lineParent) => {
                lineData.data.SupplierBatchReceivedQty = e.value;
                lineData.data.ReceivedQty =
                  lineData.data.ActualStockConversion *
                  lineData.data.SupplierBatchReceivedQty;

                let totalBatchPickedQty = 0;
                lineParent.data.ChildDataSource.forEach((x) => {
                  totalBatchPickedQty += x.SupplierBatchReceivedQty;
                });

                lineParent.data.SupplierReceivedQty = totalBatchPickedQty;

                if (
                  totalBatchPickedQty >
                  lineParent.data.SupplierOutstandingQuantity
                ) {
                  this.$nextTick(function () {
                    alert(
                      `Item : ${
                        lineParent.data.ItemDescription
                      } has a received quantity of ${formatNumber(
                        lineParent.data.SupplierReceivedQty
                      )} which is more than the outstanding quantity of ${formatNumber(
                        lineParent.data.SupplierOutstandingQuantity
                      )}.`,
                      "Validation Errors"
                    );
                  });
                }

                // lineParent.data.Completed =
                //   lineParent.data.SupplierReceivedQty >=
                //   lineParent.data.SupplierOutstandingQuantity;
              },
            },
            {
              dataField: "ActionDelete",
              listner: (e, lineData, lineParent) => {
                this.onActionDetele(e, lineData, lineParent);
              },
            },
            {
              dataField: "ActionAddNew",
              listner: (e, lineData, lineParent) => {
                if (e && lineData) {
                  let data = lineData.data;
                  if (data.IsBatchProduct == "Manual" && !data.BatchNo) {
                    this.$alert("Batch No is required", "Validation Error");
                  } else if (
                    data.IsManufacturedDateRequired == "Y" &&
                    !data.ManufacturedDate
                  ) {
                    this.$alert(
                      "Manufactured Date is required",
                      "Validation Error"
                    );
                  } else {
                    var batchNo = this.getDefaultBatchNo(lineParent);

                    lineParent.data.ChildDataSource.push({
                      BatchNo: batchNo,
                      SupplierBatchNo: "",
                      SupplierCode: "",
                      UseByDate: null,
                      SupplierBatchReceivedQty: 0,
                      ActualStockConversion: lineParent.data.SupplierConversion,
                      ReceivedQty: lineParent.data.ReceivedQty,
                      SupplierOutstandingQuantity:
                        lineParent.data.SupplierOutstandingQuantity,
                      IsManufacturedDateRequired:
                        lineParent.data.IsManufacturedDateRequired,
                      UseByShelfLife: lineParent.data.UseByShelfLife,
                      BestBeforeShelfLife: lineParent.data.BestBeforeShelfLife,
                      IsBatchProduct: lineParent.data.IsBatchProduct,
                      BestBeforeDate: undefined,
                      ManufacturedDate: undefined,
                    });
                  }
                }
              },
            },
            {
              dataField: "Completed",
              listner: this.completeCheckBoxValueChange,
            },
          ],

          ellipsisColumn: {
            items: [
              {
                label: "Line Comment",
                clickAction: "lineComment",
              },
            ],
            keyExpr: "label",
            displayExpr: "label",
            formItems: [
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    dataField: "GoodsInComment",
                    label: { text: "Comment", visible: false },
                    editorType: "dxTextArea",
                    editorOptions: {
                      maxLength: 100,
                      height: 70,
                    },
                  },
                ],
              },
            ],
          },
        },
        footerData: {
          footerItems: [
            {
              screenField: "Quantity",
              dataField: "SupplierReceivedQty",
              location: "left",
              label: "Item Count",
              value: 0,
              format: "Decimal-16-0",
            },

            {
              screenField: "SalesUMItemCount",
              dataField: "SupplierRequired",
              location: "left",
              label: "Line Count",
              value: 0,
              customCalc: (headerData, gridItems) => {
                var count = 0;
                gridItems.forEach((element) => {
                  if (element.CheckInclude) count++;
                });

                return count;
              },
            },
            {
              dataField: "ExFXTotal",
              screenField: "TaxableFXTotal",
              location: "right",
              value: 0,
              format: "Decimal-16-2C",
              label: `Sub Total (${this.dataModel.SupplierCurrencyCode})`,
            },
            {
              screenField: "TaxFXTotal",
              dataField: "TaxFXTotal",
              location: "right",
              value: 0,
              format: "Decimal-16-2C",
              label: `Tax (${this.dataModel.SupplierCurrencyCode})`,
            },
            {
              screenField: "FXTotal",
              dataField: "IncTaxFXTotal",
              location: "right",
              value: 0,
              format: "Decimal-16-2C",
              label: `Total (${this.dataModel.SupplierCurrencyCode})`,
            },
          ],
        },
      };
      return screenJson;
    },
    getLabel() {
      return this.expandChildGrid ? "Collapse" : "Expand";
    },
  },
  methods: {
    onEditorPreparing(e) {
      if (e.editorOptions && e.editorOptions.onKeyDown) {
        let func = e.editorOptions.onKeyDown;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onKeyDown = (event) => {
            func(event, {
              column: e,
              data: e.row.data,
              rowIndex: e.row.rowIndex,
              row: e.row,
            });
          };
      }

      if (e.editorOptions && e.editorOptions.onFocusOut) {
        let func = e.editorOptions.onFocusOut;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onFocusOut = (event) => {
            func(event, {
              column: e,
              data: e.row.data,
              rowIndex: e.row.rowIndex,
              row: e.row,
            });
          };
      }
    },
    onDateReceivedKeyDown(e) {
      if (e.event) {
        if (e.event.key == "Tab" && e.event.shiftKey == false) {
          e.event.preventDefault();
          let gridInstance =
            this.$refs["goods-in"].$refs.transactionGrid.getGridInstance();

          let items = gridInstance.getDataSource().items();
          let dataField = undefined;

          if (items.length > 0) {
            if (items[0].IsBatchProduct == "No") {
              dataField = "SupplierReceivedQty";
            } else {
              dataField = "GoodsInDetailComment";
            }

            this.focusOnEditingCell(0, dataField);
          }
        }
      }
    },
    onSupplierReceivedQtyKeyDown(e, cellInfo) {
      if (e.event) {
        if (e.event.key == "Tab" && e.event.shiftKey == false) {
          e.event.preventDefault();
          this.tabInToComment = true;
          this.focusOnEditingCell(cellInfo.rowIndex, "GoodsInDetailComment");
        } else if (e.event.key == "Tab" && e.event.shiftKey == true) {
          e.event.preventDefault();

          let gridInstance =
            this.$refs["goods-in"].$refs.transactionGrid.getGridInstance();

          let items = gridInstance.getDataSource().items();
          let index = items.findIndex((x) => x.ID == cellInfo.data.ID);
          let prevItem = items[index - 1];

          if (prevItem && prevItem.IsBatchProduct == "No") {
            this.focusOnEditingCell(index - 1, "GoodsInDetailComment");
          } else {
            if (index != -1 && index > 0) {
              // let rowIndex = gridInstance.getRowIndexByKey(prevItem);

              gridInstance.expandRow(prevItem).then(() => {
                setTimeout(() => {
                  let gridInstance = this.$refs[
                    "goods-in"
                  ].$refs.transactionGrid.getMasterDataInstance(
                    prevItem.LineNo
                  );

                  let items = gridInstance.getDataSource().items();

                  if (gridInstance) this.BatchGridInstance = gridInstance;

                  if (items.length > 0) {
                    e.event.preventDefault();
                    let item = cellInfo.data.ChildDataSource[0];

                    let visibleUseBy = true;
                    let visibleBestBefore = true;

                    if (
                      item.UseByShelfLife == -1 &&
                      item.BestBeforeShelfLife == -1
                    ) {
                      visibleUseBy = false;
                      visibleBestBefore = false;
                    } else if (
                      item.UseByShelfLife > -1 &&
                      item.BestBeforeShelfLife > -1
                    ) {
                      visibleBestBefore = false;
                    } else if (item.UseByShelfLife > -1) {
                      visibleBestBefore = false;
                    } else if (item.BestBeforeShelfLife > -1) {
                      visibleUseBy = false;
                    }

                    let dataField = "SupplierReceivedQty";

                    if (!item.ManufacturedDate) dataField = "ManufacturedDate";
                    else if (visibleUseBy) dataField = "UseByDate";
                    else if (visibleBestBefore) dataField = "BestBeforeDate";

                    if (gridInstance) {
                      let cellElement = gridInstance.getCellElement(
                        items.length - 1,
                        dataField
                      );
                      if (cellElement) {
                        gridInstance.focus(cellElement);
                      }
                    }
                  }
                }, 10);
              });
            } else if (index == 0) {
              setTimeout(() => {
                if (
                  this.headerToolBarForm &&
                  this.headerToolBarForm.getEditor("DateReceived")
                )
                  this.headerToolBarForm
                    .getEditor("DateReceived")
                    .instance()
                    .focus();
              }, 100);
            }
          }
        }
      }
    },
    async onGoodsInDetailCommentKeyDown(e, cellInfo) {
      if (e.event) {
        if (e.event.key == "Tab" && e.event.shiftKey == false) {
          // e.event.preventDefault();
          let gridInstance =
            this.$refs["goods-in"].$refs.transactionGrid.getGridInstance();

          if (cellInfo.data.IsBatchProduct != "No") {
            gridInstance.expandRow(cellInfo.row.key).then(() => {
              setTimeout(() => {
                let gridInstance = this.$refs[
                  "goods-in"
                ].$refs.transactionGrid.getMasterDataInstance(
                  cellInfo.data.LineNo
                );
                let items = gridInstance.getDataSource().items();

                if (gridInstance) this.BatchGridInstance = gridInstance;

                if (items.length > 0) {
                  let dataField = undefined;
                  if (items[0].IsBatchProduct == "Manual") {
                    dataField = "BatchNo";
                  } else {
                    dataField = "SupplierBatchNo";
                  }
                  if (gridInstance) {
                    let cellElement = gridInstance.getCellElement(0, dataField);
                    if (cellElement) {
                      gridInstance.focus(cellElement);
                    }
                  }
                }
              }, 10);
            });
          } else {
            // gridInstance.saveEditData();
            // setTimeout(() => {
            //   this.focusOnEditingCell(
            //     cellInfo.rowIndex + 1,
            //     "SupplierReceivedQty"
            //   );
            // }, 500);
          }
        } else if (e.event.key == "Tab" && e.event.shiftKey == true) {
          e.event.preventDefault();

          let gridInstance =
            this.$refs["goods-in"].$refs.transactionGrid.getGridInstance();

          let items = gridInstance.getDataSource().items();
          let index = items.findIndex((x) => x.ID == cellInfo.data.ID);
          let prevItem = items[index - 1];

          if (cellInfo.data.IsBatchProduct == "No") {
            this.focusOnEditingCell(cellInfo.rowIndex, "SupplierReceivedQty");
          } else if (prevItem && prevItem.IsBatchProduct == "No") {
            this.focusOnEditingCell(index - 1, "GoodsInDetailComment");
          } else {
            if (index != -1 && index > 0) {
              // let rowIndex = gridInstance.getRowIndexByKey(prevItem);

              gridInstance.expandRow(prevItem).then(() => {
                setTimeout(() => {
                  let gridInstance = this.$refs[
                    "goods-in"
                  ].$refs.transactionGrid.getMasterDataInstance(
                    prevItem.LineNo
                  );

                  let items = gridInstance.getDataSource().items();

                  if (gridInstance) this.BatchGridInstance = gridInstance;

                  if (items.length > 0) {
                    e.event.preventDefault();
                    let item = cellInfo.data.ChildDataSource[0];

                    let visibleUseBy = true;
                    let visibleBestBefore = true;

                    if (
                      item.UseByShelfLife == -1 &&
                      item.BestBeforeShelfLife == -1
                    ) {
                      visibleUseBy = false;
                      visibleBestBefore = false;
                    } else if (
                      item.UseByShelfLife > -1 &&
                      item.BestBeforeShelfLife > -1
                    ) {
                      visibleBestBefore = false;
                    } else if (item.UseByShelfLife > -1) {
                      visibleBestBefore = false;
                    } else if (item.BestBeforeShelfLife > -1) {
                      visibleUseBy = false;
                    }

                    let dataField = "SupplierReceivedQty";

                    if (!item.ManufacturedDate) dataField = "ManufacturedDate";
                    else if (visibleUseBy) dataField = "UseByDate";
                    else if (visibleBestBefore) dataField = "BestBeforeDate";

                    if (gridInstance) {
                      let cellElement = gridInstance.getCellElement(
                        items.length - 1,
                        dataField
                      );
                      if (cellElement) {
                        gridInstance.focus(cellElement);
                      }
                    }
                  }
                }, 10);
              });
            } else if (index == 0) {
              setTimeout(() => {
                if (
                  this.headerToolBarForm &&
                  this.headerToolBarForm.getEditor("DateReceived")
                )
                  this.headerToolBarForm
                    .getEditor("DateReceived")
                    .instance()
                    .focus();
              }, 100);
            }
          }
        }
      }
    },
    // onGoodsInDetailCommentFocusOut(e, cellInfo) {
    //   let gridInstance =
    //     this.$refs["goods-in"].$refs.transactionGrid.getGridInstance();
    // },
    onCollapseBtnContentReady(e) {
      this.CollapseBtnContentReady = e;
    },
    onBatchNoUpdate(e, lineData, lineParent) {
      GoodsInService.getGoodsInBatches(
        `ItemCode eq '${lineParent.data.ItemCode}' and SupplierCode eq '${this.dataModel.SupplierCode}' and BatchNo eq '${e.value}'`
      ).then((res) => {
        if (res.data.value.length > 0) {
          let data = res.data.value[0];
          lineData.data.SupplierBatchNo = data.SupplierBatchNo;
          if (data.ManufacturedDate)
            lineData.data.ManufacturedDate = new Date(data.ManufacturedDate);
          if (data.BestBeforeDate)
            lineData.data.BestBeforeDate = new Date(data.BestBeforeDate);
          if (data.UseByDate)
            lineData.data.UseByDate = new Date(data.UseByDate);

          lineData.data.FromBatchDB = true;
        } else {
          lineData.data.FromBatchDB = false;
        }
      });
    },
    getChildColumns(data) {
      let item = data.data;

      let visibleUseBy = true;
      let visibleBestBefore = true;
      // let changeWidth = 0;

      if (item.UseByShelfLife == -1 && item.BestBeforeShelfLife == -1) {
        visibleUseBy = false;
        visibleBestBefore = false;
        // changeWidth = ColumnWidth.Date.width / 2;
      } else if (item.UseByShelfLife > -1 && item.BestBeforeShelfLife > -1) {
        visibleBestBefore = false;
      } else if (
        item.UseByShelfLife > -1
        // && item.BestBeforeShelfLife != -1
      ) {
        visibleBestBefore = false;
      } else if (
        item.BestBeforeShelfLife > -1
        // && item.UseByShelfLife != -1
      ) {
        visibleUseBy = false;
      }

      return [
        {
          screenField: "Batch",
          gridDataField: "BatchNo",
          allowEditing: false,
          showEditorAlways: false,
          cellTemplate: "EditableText",
          makeDisabled: (data) => {
            return data.data.BatchNo == "System Generated";
          },
          width: ColumnWidth.BatchNo.width + 260,
          minWidth: ColumnWidth.BatchNo.minWidth + 260,
          customClass: (data) => {
            if (data.data.IsBatchProduct == "Manual" && !data.data.BatchNo) {
              return "gc-require-validation gc-grid-number-box-editor";
            } else return "gc-grid-number-box-editor";
          },
          editorOptions: {
            onKeyDown: (e, cellInfo, lineInfo) => {
              this.onBatchNoKeyDown(e, cellInfo, lineInfo);
            },
          },
        },
        {
          screenField: "SupplierBatchNo",
          cellTemplate: "EditableText",
          width: ColumnWidth.SupplierBatchNo.width + 260,
          minWidth: ColumnWidth.SupplierBatchNo.minWidth + 260,
          makeDisabled: (data) => {
            return data.data.FromBatchDB;
          },
          editorOptions: {
            onKeyDown: (e, cellInfo, lineInfo) => {
              this.onSupplierBatchNoKeyDown(e, cellInfo, lineInfo);
            },
          },
        },
        {
          screenField: "Quantity",
          dataField: "SupplierOutstandingQuantity",
          format: "Decimal-16-2",
          label: "Outstanding",
          width: ColumnWidth.Quantity2DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity2DecimalPoints.maxWidth,
        },
        {
          screenField: "Quantity",
          dataField: "SupplierBatchReceivedQty",
          editCellTemplate: "EditableDecimal",
          // editCellTemplate: "EditableDecimal",
          showEditorAlways: true,
          format: "Decimal-16-2",
          label: "Received",
          width: ColumnWidth.Quantity2DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity2DecimalPoints.maxWidth,
          cssClass: "gc-num-input",
          editorOptions: {
            onKeyDown: (e, cellInfo, lineInfo) => {
              this.onSupplierBatchReceivedQtyKeyDown(e, cellInfo, lineInfo);
            },
          },
          allowEditing: true,
        },
        {
          screenField: "DateIn",
          label: "Manufactured Date",
          gridDataField: "ManufacturedDate",
          allowEditing: false,
          allowSearch: false,
          allowFiltering: false,
          cellTemplate: "Date",
          editable: true,
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
          customClass: (data) => {
            if (
              data.data.IsManufacturedDateRequired == "Y" &&
              !data.data.ManufacturedDate
            ) {
              return "gc-require-validation";
            } else return "";
          },
          makeReadOnly: (data) => {
            return data.data.FromBatchDB;
          },
          editorOptions: {
            onKeyDown: (e, cellInfo, lineInfo) => {
              this.onManufacturedDateKeyDown(e, cellInfo, lineInfo);
            },
          },
        },
        {
          screenField: "UseByDate",
          allowEditing: false,
          allowSearch: false,
          allowFiltering: false,
          cellTemplate: "Date",
          editable: true,
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
          visible: visibleUseBy,
          makeReadOnly: (data) => {
            return !data.data.ManufacturedDate || data.data.FromBatchDB;
          },
          editorOptions: {
            onKeyDown: (e, cellInfo, lineInfo) => {
              this.onUseByDateKeyDown(e, cellInfo, lineInfo);
            },
          },
        },
        {
          screenField: "BestBeforeDate",
          allowEditing: false,
          allowSearch: false,
          allowFiltering: false,
          cellTemplate: "Date",
          editable: true,
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
          visible: visibleBestBefore,
          makeReadOnly: (data) => {
            return !data.data.ManufacturedDate || data.data.FromBatchDB;
          },
          editorOptions: {
            onKeyDown: (e, cellInfo, lineInfo) => {
              this.onBestUseDateKeyDown(e, cellInfo, lineInfo);
            },
          },
        },
        {
          dataField: "ActionAddNew",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionAddNew",
        },
        {
          dataField: "ActionDelete",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionDelete",
        },
      ];
    },
    onBatchNoKeyDown(e, cellInfo, lineInfo) {
      if (e.event) {
        let item = cellInfo.data;
        let instance = cellInfo.component;

        let visibleUseBy = true;
        let visibleBestBefore = true;

        if (item.UseByShelfLife == -1 && item.BestBeforeShelfLife == -1) {
          visibleUseBy = false;
          visibleBestBefore = false;
        } else if (item.UseByShelfLife > -1 && item.BestBeforeShelfLife > -1) {
          visibleBestBefore = false;
        } else if (item.UseByShelfLife > -1) {
          visibleBestBefore = false;
        } else if (item.BestBeforeShelfLife > -1) {
          visibleUseBy = false;
        }
        if (e.event.key == "Tab" && e.event.shiftKey == false) {
          setTimeout(() => {
            if (instance) {
              let cellElement = instance.getCellElement(
                cellInfo.rowIndex,
                "SupplierBatchNo"
              );
              if (cellElement) {
                instance.focus(cellElement);
              }
            }
          }, 100);
        } else if (e.event.key == "Tab" && e.event.shiftKey == true) {
          e.event.preventDefault();

          let items = instance.getDataSource().items();

          if (items.length > 0 && cellInfo.rowIndex != 0) {
            let dataField = undefined;

            if (visibleUseBy) dataField = "UseByDate";
            else if (visibleBestBefore) dataField = "BestBeforeDate";

            setTimeout(() => {
              if (instance) {
                let cellElement = instance.getCellElement(
                  cellInfo.rowIndex - 1,
                  dataField
                );
                if (cellElement) {
                  instance.focus(cellElement);
                }
              }
            }, 100);
          } else
            this.focusOnEditingCell(
              lineInfo.rowIndex - 1,
              "GoodsInDetailComment"
            );
        }
      }
    },
    onSupplierBatchNoKeyDown(e, cellInfo, lineInfo) {
      if (e.event) {
        if (e.event.key == "Tab" && e.event.shiftKey == false) {
          e.event.preventDefault();

          setTimeout(() => {
            let instance = cellInfo.component;

            // instance.saveEditData().then(() => {
            if (instance) {
              let cellElement = instance.getCellElement(
                cellInfo.rowIndex,
                "SupplierBatchReceivedQty"
              );
              if (cellElement) {
                instance.focus(cellElement);

                // setTimeout(() => {
                //   instance.editCell(
                //     cellInfo.rowIndex,
                //     "SupplierBatchReceivedQty"
                //   );
                // }, 10);
              }
            }
            // });
          }, 300);
        } else if (e.event.key == "Tab" && e.event.shiftKey == true) {
          if (lineInfo.data.IsBatchProduct != "Manual") {
            e.event.preventDefault();
            this.focusOnEditingCell(
              lineInfo.rowIndex - 1,
              "GoodsInDetailComment"
            );
          }
        }
      }
    },
    onSupplierBatchReceivedQtyKeyDown(e, cellInfo) {
      if (e.event) {
        let instance = cellInfo.component;
        if (e.event.key == "Tab" && e.event.shiftKey == false) {
          e.event.preventDefault();
          // instance.cellValue(cellInfo.rowIndex, "SupplierBatchReceivedQty", cellInfo.data.SupplierBatchReceivedQty);
          // instance.saveEditData().then(() => {
          setTimeout(() => {
            if (instance) {
              let cellElement = instance.getCellElement(
                cellInfo.rowIndex,
                "ManufacturedDate"
              );
              if (cellElement) {
                // instance.editCell(cellInfo.rowIndex, "ManufacturedDate");

                setTimeout(() => {
                  instance.focus(cellElement);
                }, 10);
              }
            }
          }, 200);
          // });
        } else if (e.event.key == "Tab" && e.event.shiftKey == true) {
          e.event.preventDefault();

          setTimeout(() => {
            if (instance) {
              let cellElement = instance.getCellElement(
                cellInfo.rowIndex,
                "SupplierBatchNo"
              );
              if (cellElement) {
                instance.focus(cellElement);
              }
            }
          }, 200);
        }
      }
    },
    onManufacturedDateKeyDown(e, cellInfo, lineInfo) {
      if (e.event) {
        let item = cellInfo.data;

        let visibleUseBy = true;
        let visibleBestBefore = true;

        if (item.UseByShelfLife == -1 && item.BestBeforeShelfLife == -1) {
          visibleUseBy = false;
          visibleBestBefore = false;
        } else if (item.UseByShelfLife > -1 && item.BestBeforeShelfLife > -1) {
          visibleBestBefore = false;
        } else if (item.UseByShelfLife > -1) {
          visibleBestBefore = false;
        } else if (item.BestBeforeShelfLife > -1) {
          visibleUseBy = false;
        }
        if (e.event.key == "Tab" && e.event.shiftKey == false) {
          e.event.preventDefault();
          if (!cellInfo.data.ManufacturedDate || cellInfo.data.FromBatchDB) {
            let dataField = undefined;
            if (cellInfo.data.IsBatchProduct.toLowerCase() == "no") {
              dataField = "SupplierReceivedQty";
            } else {
              dataField = "GoodsInDetailComment";
            }

            this.focusOnEditingCell(lineInfo.rowIndex + 1, dataField);
          } else {
            let dataField = undefined;

            if (visibleUseBy) dataField = "UseByDate";
            else if (visibleBestBefore) dataField = "BestBeforeDate";

            if (dataField) {
              let instance = cellInfo.component;

              setTimeout(() => {
                if (instance) {
                  let cellElement = instance.getCellElement(
                    cellInfo.rowIndex,
                    dataField
                  );
                  if (cellElement) {
                    instance.focus(cellElement);
                  }
                }
              }, 100);
            }
          }
        } else if (e.event.key == "Tab" && e.event.shiftKey == true) {
          let instance = cellInfo.component;

          setTimeout(() => {
            if (instance) {
              let cellElement = instance.getCellElement(
                cellInfo.rowIndex,
                "SupplierBatchReceivedQty"
              );
              if (cellElement) {
                instance.focus(cellElement);
              }
            }
          }, 100);
        }
      }
    },
    onUseByDateKeyDown(e, cellInfo, lineInfo) {
      if (e.event) {
        let item = cellInfo.data;
        let instance = cellInfo.component;
        let dataField = undefined;

        // let visibleUseBy = true;
        let visibleBestBefore = true;

        if (item.UseByShelfLife == -1 && item.BestBeforeShelfLife == -1) {
          // visibleUseBy = false;
          visibleBestBefore = false;
        } else if (item.UseByShelfLife > -1 && item.BestBeforeShelfLife > -1) {
          visibleBestBefore = false;
        } else if (item.UseByShelfLife > -1) {
          visibleBestBefore = false;
        } else if (item.BestBeforeShelfLife > -1) {
          // visibleUseBy = false;
        }
        if (e.event.key == "Tab" && e.event.shiftKey == false) {
          e.event.preventDefault();

          if (visibleBestBefore) {
            dataField = "BestUseDate";

            setTimeout(() => {
              if (instance) {
                let cellElement = instance.getCellElement(
                  cellInfo.rowIndex,
                  dataField
                );
                if (cellElement) {
                  instance.focus(cellElement);
                }
              }
            }, 100);
          } else {
            let items = instance.getDataSource().items();
            if (items.length > cellInfo.rowIndex) {
              if (lineInfo.data.IsBatchProduct == "Manual") {
                dataField = "BatchNo";
              } else dataField = "SupplierBatchNo";

              setTimeout(() => {
                if (instance) {
                  let cellElement = instance.getCellElement(
                    cellInfo.rowIndex + 1,
                    dataField
                  );
                  if (cellElement) {
                    instance.focus(cellElement);
                  }
                }
              }, 100);
            }
          }
        } else if (e.event.key == "Tab" && e.event.shiftKey == true) {
          setTimeout(() => {
            if (instance) {
              let cellElement = instance.getCellElement(
                cellInfo.rowIndex,
                "ManufacturedDate"
              );
              if (cellElement) {
                instance.focus(cellElement);
              }
            }
          }, 100);
        }
      }
    },
    onBestUseDateKeyDown(e, cellInfo, lineInfo) {
      if (e.event) {
        let instance = cellInfo.component;
        let dataField = undefined;
        let item = cellInfo.data;

        let visibleUseBy = true;
        let visibleBestBefore = true;

        if (item.UseByShelfLife == -1 && item.BestBeforeShelfLife == -1) {
          visibleUseBy = false;
          visibleBestBefore = false;
        } else if (item.UseByShelfLife > -1 && item.BestBeforeShelfLife > -1) {
          visibleBestBefore = false;
        } else if (item.UseByShelfLife > -1) {
          visibleBestBefore = false;
        } else if (item.BestBeforeShelfLife > -1) {
          visibleUseBy = false;
        }
        if (e.event.key == "Tab" && e.event.shiftKey == false) {
          e.event.preventDefault();

          let items = instance.getDataSource().items();
          if (items.length > cellInfo.rowIndex) {
            if (lineInfo.data.IsBatchProduct == "Manual") {
              dataField = "BatchNo";
            } else dataField = "SupplierBatchNo";

            setTimeout(() => {
              if (instance) {
                let cellElement = instance.getCellElement(
                  cellInfo.rowIndex + 1,
                  dataField
                );
                if (cellElement) {
                  instance.focus(cellElement);
                }
              }
            }, 100);
          } else {
            if (lineInfo.data.IsBatchProduct.toLowerCase() == "no") {
              dataField = "SupplierReceivedQty";
            } else {
              dataField = "GoodsInDetailComment";
            }

            this.focusOnEditingCell(lineInfo.rowIndex + 1, dataField);
          }
        } else if (e.event.key == "Tab" && e.event.shiftKey == true) {
          if (visibleUseBy) dataField = "UseByDate";
          else if (visibleBestBefore) dataField = "SupplierBatchReceivedQty";

          setTimeout(() => {
            if (instance) {
              let cellElement = instance.getCellElement(
                cellInfo.rowIndex,
                dataField
              );
              if (cellElement) {
                instance.focus(cellElement);
              }
            }
          }, 100);
        }
      }
    },
    onContentReadyCallBack() {
      if (this.gridDataLoaded == false) {
        this.gridDataLoaded = true;
        setTimeout(() => {
          this.expandMasterDetailsSection();
        }, 500);
      }
    },
    expandMasterDetailsSection() {
      let gridInstance =
        this.$refs["goods-in"].$refs.transactionGrid.getGridInstance();

      let items = gridInstance.getDataSource().items();
      if (this.expandChildGrid) {
        this.expandChildGrid = false;
        // gridInstance.collapseAll(-1);
        items.forEach((element, index) => {
          if (element.ChildDataSource && element.ChildDataSource.length > 0) {
            setTimeout(() => {
              gridInstance.collapseRow(element);
            }, 100 * index);
          }
        });
      } else {
        this.expandChildGrid = true;
        items.forEach((element, index) => {
          if (element.ChildDataSource && element.ChildDataSource.length > 0) {
            setTimeout(() => {
              gridInstance.expandRow(element);
            }, 100 * index);
          }
        });
      }
      setTimeout(() => {
        gridInstance.refresh(true).then(() => {
          this.updateHeaderCheckBox(items);

          if (this.CollapseBtnContentReady) {
            this.CollapseBtnContentReady.component.beginUpdate();
            this.CollapseBtnContentReady.component.option(
              "text",
              this.getLabel
            );
            this.CollapseBtnContentReady.component.option(
              "icon",
              this.expandChildGrid ? "chevronup" : "chevrondown"
            );
            this.CollapseBtnContentReady.component.endUpdate();
          }
        });
      }, 100);
    },
    async onRequiredQtyValidations(e, lineData) {
      // var { row, data } = lineData;
      if (
        lineData.row &&
        lineData.row.data &&
        lineData.row.data.IsBatchProduct == "No"
      ) {
        // non batched products
        if (lineData.data.CheckInclude) {
          // checked
          if (lineData.data.RequiredQty < 0) {
            if (e.value <= lineData.data.SupplierOutstandingQuantity)
              lineData.data.Completed = true;
            else lineData.data.Completed = false;
          } else if (e.value < lineData.data.SupplierOutstandingQuantity) {
            lineData.data.Completed = false;
            this.disableCompleteHeader(false);
          } else {
            lineData.data.Completed = true;
          }
        } else {
          // unchecked
          lineData.data.CheckInclude = true;

          if (lineData.data.RequiredQty < 0) {
            if (e.value <= lineData.data.SupplierOutstandingQuantity)
              lineData.data.Completed = true;
            else lineData.data.Completed = false;
          } else if (e.value < lineData.data.SupplierOutstandingQuantity) {
            lineData.data.Completed = false;
          } else {
            lineData.data.Completed = true;
          }
        }
      } else {
        if (lineData.data.CheckInclude) {
          if (
            lineData.data.SupplierReceivedQty >=
            lineData.data.SupplierOutstandingQuantity
          ) {
            lineData.data.Completed = true;
          }
        }
      }

      if (lineData.data.RequiredQty >= 0 && e.value < 0) {
        await alert(
          `${lineData.data.ItemDescription} has a Required quantity that is greater than 0.00. The Received quantity should be greater than 0.00.`,
          "Validation Errors"
        );
        this.focusOnEditingCell(lineData.rowIndex, lineData.column.dataField);
      } else if (lineData.data.RequiredQty < 0 && e.value > 0) {
        await alert(
          `${lineData.data.ItemDescription} has a Required quantity that is less than 0.00. The Received quantity should be less than 0.00.`,
          "Validation Errors"
        );
        this.focusOnEditingCell(lineData.rowIndex, lineData.column.dataField);
      } else if (
        lineData.data.RequiredQty > 0 &&
        e.value > lineData.data.SupplierOutstandingQuantity
      ) {
        lineData.data.SupplierReceivedQty = e.value;
        await alert(
          `${
            lineData.data.ItemDescription
          } has a Received quantity of ${formatNumber(
            e.value
          )} which is more than the Outstanding quantity of ${formatNumber(
            lineData.data.SupplierOutstandingQuantity
          )}. Please update the Received quantity if you do not wish to over-receive against this line.`,
          "Validation Errors"
        );
        this.focusOnEditingCell(lineData.rowIndex, lineData.column.dataField);
      } else if (
        lineData.data.RequiredQty < 0 &&
        e.value < lineData.data.SupplierOutstandingQuantity
      ) {
        lineData.data.SupplierReceivedQty = e.value;
        await alert(
          `${
            lineData.data.ItemDescription
          } has a Received quantity of ${formatNumber(
            e.value
          )} which is less than the Outstanding quantity of ${formatNumber(
            lineData.data.SupplierOutstandingQuantity
          )}. Please update the Received quantity if you do not wish to over-receive against this line.`,
          "Validation Errors"
        );
        this.focusOnEditingCell(lineData.rowIndex, lineData.column.dataField);
      } else {
        lineData.data.SupplierReceivedQty = e.value;
      }

      var gridItems = lineData.component.getDataSource().items();
      // this.onSupplierReceivedQtyChange(e, lineData, gridItems);
      // else {
      e.component.beginUpdate();
      e.component.option("value", lineData.data.SupplierReceivedQty);
      e.component.endUpdate();
      // lineData.data.SupplierReceivedQty = e.value;
      // }

      lineData.data.ExFXTotal = (
        lineData.data.SupplierReceivedQty * lineData.data.SupplierFXPrice
      ).toFixed(2);

      if (lineData.data.TaxPcnt != 0) {
        lineData.data.TaxFXTotal = (
          lineData.data.ExFXTotal *
          (1 / lineData.data.TaxPcnt)
        ).toFixed(2);

        lineData.data.IncTaxFXTotal =
          parseFloat(
            lineData.data.SupplierReceivedQty * lineData.data.SupplierFXPrice
          ) + parseFloat(lineData.data.ExFXTotal * (1 / lineData.data.TaxPcnt));
      } else {
        lineData.data.TaxFXTotal = 0;

        lineData.data.IncTaxFXTotal = parseFloat(
          lineData.data.SupplierReceivedQty * lineData.data.SupplierFXPrice
        );
      }

      let includeItems = gridItems.filter((x) => x.CheckInclude);
      let completeItems = includeItems.filter((x) => x.Completed);

      if (includeItems.length == completeItems.length)
        this.disableCompleteHeader(true);
      else this.disableCompleteHeader(false);

      // if (e.value >= lineData.data.SupplierOutstandingQuantity)
      //   lineData.data.Completed = true;
      // else lineData.data.Completed = false;

      this.updateHeaderCheckBox(gridItems);

      if (this.tabInToComment) {
        this.tabInToComment = false;
        this.focusOnEditingCell(lineData.rowIndex, "GoodsInDetailComment");
      }
    },
    focusOnEditingCell(rowIndex, dataField) {
      // console.log("focusOnEditingCell ", rowIndex, dataField);
      setTimeout(() => {
        let gridInstance =
          this.$refs["goods-in"].$refs.transactionGrid.getGridInstance();
        if (gridInstance) {
          let cellElement = gridInstance.getCellElement(rowIndex, dataField);
          // console.log(">> ", cellElement);
          if (cellElement) {
            gridInstance.focus(cellElement);
            // setTimeout(() => {
            //   gridInstance.editCell(rowIndex, dataField);
            // }, 10);
          }
        }
      }, 500);
    },
    formContentReady(e) {
      if (e && this.baseView.mode != "review" && this.loaded)
        setTimeout(() => {
          this.headerToolBarForm = e.component;
          if (
            this.headerToolBarForm &&
            this.headerToolBarForm.getEditor("DateIn")
          )
            this.headerToolBarForm.getEditor("DateIn").instance().focus();
        }, 500);
    },
    onCellPreparedCallBack(e) {
      if (e.rowType === "data" || e.rowType === "header") {
        var self = this;

        if (e.column.dataField === "CheckInclude") {
          on(e.cellElement, "mouseover", (arg) => {
            self.$refs[this.tooltipRefName].instance.show(arg.target);
          });

          on(e.cellElement, "mouseout", () => {
            self.$refs[this.tooltipRefName].instance.hide();
          });
        }

        if (e.column.dataField === "Completed") {
          on(e.cellElement, "mouseover", (arg) => {
            self.$refs[this.CompleteTooltipRefName].instance.show(arg.target);
          });

          on(e.cellElement, "mouseout", () => {
            self.$refs[this.CompleteTooltipRefName].instance.hide();
          });
        }
      }
    },
    async enableAddGoodsInOrderItem() {
      this.addGoodsInItem = {
        visible: true,
        addSalesOrderItemData: {
          ...this.$refs["goods-in"].getTransactionData(),
          DivisionCode: this.purchaseOrderDetail.DivisionCode,
          PurchaseOrderCode: this.purchaseOrderDetail.PurchaseOrderCode,
          BranchCode: this.purchaseOrderDetail.BranchCode,
          orderType: "gi",
        },
        popUpCallBack: this.addGoodsInCallback,
      };
    },
    addGoodsInCallback(update) {
      this.addGoodsInItem = undefined;
      if (update) {
        this.refreshDataGrid = true;
        setTimeout(() => {
          this.refreshDataGrid = false;
        }, 100);
      }
    },
    enableEditGoodsInItem(data) {
      this.editGoodsInItem = {
        visible: true,
        editProductItemData: {
          DivisionCode: data.DivisionCode,
          PurchaseOrderCode: data.PurchaseOrderCode,
          ItemCode: data.ItemCode,
          ItemType: data.ItemType,
          TaxCode: data.TaxCode,
          ItemDescription: data.ItemDescription,
          SalesUM: data.SupplierUM,
          SalesUMOrderQty: data.SupplierReceivedQty,
          SalesUMFXPrice: data.SupplierFXPrice,
          SalesTaxPcnt: data.TaxPcnt,
          DiscPcnt: data.DiscPcnt,
          Comment: data.Comment,
          Amount: data.FXLineTotal,
          ID: data.LineNo,
          BranchCode: data.BranchCode,
          SupplierCode: this.dataModel.SupplierCode,
          ETADate: data.ETADate,
          RequiredByDate: data.RequiredByDate,
          orderType: "gi",
        },
        popUpCallBack: this.editItemCallback,
        model: this.$refs["goods-in"].getTransactionData(),
      };
    },
    editItemCallback(update) {
      this.editGoodsInItem = undefined;
      if (update) {
        this.refreshDataGrid = true;
        setTimeout(() => {
          this.refreshDataGrid = false;
        }, 100);
      }
    },
    getDefaultBatchNo(lineParent) {
      return lineParent.data.IsBatchProduct == "NextNo" ||
        lineParent.data.IsBatchProduct == "Auto"
        ? "System Generated"
        : "";
    },
    async onActionDetele(e, lineData, lineParent) {
      let confirmDelete = await this.$confirm(
        "Are you sure you want to delete this record?",
        "Delete"
      );

      if (confirmDelete && e) {
        lineParent.data.SupplierReceivedQty -= lineData.data.SupplierBatchReceivedQty;
        lineParent.data.Completed = lineParent.data.SupplierReceivedQty >= lineParent.data.SupplierOutstandingQuantity;
        lineParent.data.ChildDataSource.splice(lineData.rowIndex, 1);
        if (lineParent.data.ChildDataSource.length == 0) {
          var batchNo = this.getDefaultBatchNo(lineParent);

          lineParent.data.ChildDataSource.push({
            BatchNo: batchNo,
            SupplierBatchNo: "",
            SupplierCode: "",
            UseByDate: null,
            SupplierBatchReceivedQty: 0,
            ActualStockConversion: lineParent.data.SupplierConversion,
            ReceivedQty: lineParent.data.ReceivedQty,
          });
        }
      }
    },
    completeCheckBoxValueChange(lineData, recordData) {
      if (recordData.rowType === "header") {
        let gridItems = recordData.component.getDataSource().items();

        gridItems.forEach((element) => {
          if (element.CheckInclude && element.IsBatchProduct == "No") {
            if (lineData.value) {
              if (
                lineData.previousValue == undefined &&
                element.Completed &&
                element.SupplierReceivedQty !=
                  element.SupplierOutstandingQuantity
              )
                element.Completed = false;
              else element.Completed = lineData.value;
            } else {
              if (
                element.SupplierReceivedQty !=
                element.SupplierOutstandingQuantity
              )
                element.Completed = lineData.value;
            }
          }
        });

        this.updateHeaderCheckBox(gridItems);
      } else {
        recordData.data.Completed = lineData.value;
        if (recordData.data.IsBatchProduct == "No") {
          // non batched
          if (!recordData.data.CheckInclude) {
            // not checked
            if (recordData.data.Completed) {
              // completed
              recordData.data.CheckInclude = true;
              recordData.data.SupplierReceivedQty =
                recordData.data.SupplierOutstandingQuantity;
            }
          }
        } else {
          // batched
          if (!recordData.data.CheckInclude) {
            // not checked
            if (recordData.data.Completed) {
              recordData.data.CheckInclude = true;
            }
          }
        }
        var gridItems = recordData.component.getDataSource().items();
        this.updateHeaderCheckBox(gridItems);
      }
    },
    async checkBoxValueChange(fieldData, recordData) {
      if (!fieldData.event) return;
      var gridItems = recordData.component.getDataSource().items();
      if (!fieldData.event) return;
      if (recordData.rowType == "header") {
        if (fieldData.value == undefined) return;
        else {
          gridItems.forEach((element) => {
            if (fieldData.value) {
              element.CheckInclude = true;
              if (
                element.ChildDataSource &&
                element.ChildDataSource.length > 0
              ) {
                var total = 0;
                element.ChildDataSource.forEach((batch) => {
                  batch.SupplierBatchReceivedQty =
                    element.SupplierOutstandingQuantity - batch.ReceivedQty;
                  total = total + batch.SupplierBatchReceivedQty;
                });
                element.SupplierReceivedQty = total;

                element.ExFXTotal = (
                  parseFloat(total) * element.SupplierFXPrice
                ).toFixed(2);

                if (element.TaxPcnt != 0) {
                  element.TaxFXTotal = (
                    element.ExFXTotal *
                    (1 / element.TaxPcnt)
                  ).toFixed(2);

                  element.IncTaxFXTotal =
                    parseFloat(total * element.SupplierFXPrice) +
                    parseFloat(element.ExFXTotal * (1 / element.TaxPcnt));
                } else {
                  element.TaxFXTotal = 0;

                  element.IncTaxFXTotal = parseFloat(
                    total * element.SupplierFXPrice
                  );
                }

                this.onSupplierReceivedQtyChange(
                  { value: total },
                  { data: element },
                  gridItems
                );
              } else {
                element.SupplierReceivedQty =
                  element.SupplierOutstandingQuantity;
                element.Completed = true;

                element.ExFXTotal = (
                  element.SupplierReceivedQty * element.SupplierFXPrice
                ).toFixed(2);
                if (element.TaxPcnt != 0) {
                  element.TaxFXTotal = (
                    element.ExFXTotal *
                    (1 / element.TaxPcnt)
                  ).toFixed(2);
                  element.IncTaxFXTotal = (
                    parseFloat(
                      element.SupplierReceivedQty * element.SupplierFXPrice
                    ) + parseFloat(element.ExFXTotal * (1 / element.TaxPcnt))
                  ).toFixed(2);
                } else {
                  element.TaxFXTotal = 0;
                  element.IncTaxFXTotal = parseFloat(
                    element.SupplierReceivedQty * element.SupplierFXPrice
                  ).toFixed(2);
                }
                this.onSupplierReceivedQtyChange(
                  {
                    value:
                      element.SupplierOutstandingQuantity -
                      element.SupplierReceivedQty,
                  },
                  { data: element },
                  gridItems
                );
              }
              this.disableCompleteHeader(true);
            } else {
              element.CheckInclude = false;
              element.ExFXTotal = 0;
              element.TaxFXTotal = 0;
              element.IncTaxFXTotal = 0;
              element.SupplierReceivedQty = 0;
              element.Completed = false;

              if (
                element.ChildDataSource &&
                element.ChildDataSource.length > 0
              ) {
                element.ChildDataSource.forEach((batch) => {
                  batch.SupplierBatchReceivedQty = 0;
                });
              }
              this.onSupplierReceivedQtyChange(
                { value: fieldData.value ? element.SupplierReceivedQty : 0 },
                { data: element },
                gridItems
              );
            }
          });
        }
        return;
      } else {
        if (recordData.data.IsBatchProduct == "No") {
          // non batched product
          if (fieldData.value) {
            // checked
            recordData.data.CheckInclude = true;
            recordData.data.SupplierReceivedQty =
              recordData.data.SupplierOutstandingQuantity;
            recordData.data.Completed = true;
            recordData.data.ExFXTotal = (
              recordData.data.SupplierReceivedQty *
              recordData.data.SupplierFXPrice
            ).toFixed(2);

            if (recordData.data.TaxPcnt != 0) {
              recordData.data.TaxFXTotal = (
                recordData.data.ExFXTotal *
                (1 / recordData.data.TaxPcnt)
              ).toFixed(2);

              recordData.data.IncTaxFXTotal =
                parseFloat(
                  recordData.data.SupplierReceivedQty *
                    recordData.data.SupplierFXPrice
                ) +
                parseFloat(
                  recordData.data.ExFXTotal * (1 / recordData.data.TaxPcnt)
                );
            } else {
              recordData.data.TaxFXTotal = 0;

              recordData.data.IncTaxFXTotal = parseFloat(
                recordData.data.SupplierReceivedQty *
                  recordData.data.SupplierFXPrice
              );
            }
          } else {
            // unchecked
            recordData.data.CheckInclude = false;
            recordData.data.SupplierReceivedQty = 0;
            recordData.data.Completed = false;
            recordData.data.ExFXTotal = 0;
            recordData.data.TaxFXTotal = 0;
            recordData.data.IncTaxFXTotal = 0;
          }
        } else {
          // batched product
          if (fieldData.value) {
            // checked
            recordData.data.CheckInclude = true;
            recordData.data.SupplierReceivedQty = 0;
            recordData.data.Completed = false;
            recordData.data.ExFXTotal = 0;
            recordData.data.TaxFXTotal = 0;
            recordData.data.IncTaxFXTotal = 0;
          } else {
            // Unchecked
            if (recordData.data.SupplierReceivedQty >= 0) {
              recordData.data.CheckInclude = false;
              recordData.data.SupplierReceivedQty = 0;
              recordData.data.Completed = false;
              recordData.data.ExFXTotal = 0;
              recordData.data.TaxFXTotal = 0;
              recordData.data.IncTaxFXTotal = 0;
            }
          }
        }

        if (fieldData.value) {
          // checked
          // recordData.data.CheckInclude = true;

          if (
            recordData.data.ChildDataSource &&
            recordData.data.ChildDataSource.length > 0
          ) {
            var total = 0;
            await recordData.data.ChildDataSource.forEach((batch) => {
              batch.SupplierBatchReceivedQty =
                recordData.data.SupplierOutstandingQuantity - batch.ReceivedQty;

              total = total + batch.SupplierBatchReceivedQty;
              this.onSupplierBatchReceivedQtyChange(
                { value: batch.SupplierBatchReceivedQty },
                { data: batch },
                gridItems,
                "grid",
                recordData
              );
            });

            recordData.data.ExFXTotal = (
              parseFloat(total) * recordData.data.SupplierFXPrice
            ).toFixed(2);

            if (recordData.data.TaxPcnt != 0) {
              recordData.data.TaxFXTotal = (
                recordData.data.ExFXTotal *
                (1 / recordData.data.TaxPcnt)
              ).toFixed(2);

              recordData.data.IncTaxFXTotal =
                parseFloat(total * recordData.data.SupplierFXPrice) +
                parseFloat(
                  recordData.data.ExFXTotal * (1 / recordData.data.TaxPcnt)
                );
            } else {
              recordData.data.TaxFXTotal = 0;

              recordData.data.IncTaxFXTotal = parseFloat(
                total * recordData.data.SupplierFXPrice
              );
            }

            this.onSupplierReceivedQtyChange(
              { value: total },
              recordData,
              gridItems
            );
          } else
            this.onSupplierReceivedQtyChange(
              { value: recordData.data.SupplierReceivedQty },
              recordData,
              gridItems
            );
        } else {
          // unchecked
          if (
            recordData.data.ChildDataSource &&
            recordData.data.ChildDataSource.length > 0
          ) {
            recordData.data.ChildDataSource.forEach((batch) => {
              batch.SupplierBatchReceivedQty = 0;
            });
          }

          // recordData.data.CheckInclude = false;
          this.onSupplierReceivedQtyChange({ value: 0 }, recordData, gridItems);
        }
      }
      recordData.data.CheckInclude = fieldData.value;

      this.updateHeaderCheckBox(gridItems);
    },
    onSupplierBatchReceivedQtyChange(e, lineData, items, grid, lineParent) {
      lineData.data.SupplierBatchReceivedQty = e.value;
      let totalBatchPickedQty = 0;
      lineParent.data.ChildDataSource.forEach((x) => {
        totalBatchPickedQty += x.SupplierBatchReceivedQty
          ? x.SupplierBatchReceivedQty
          : 0;
      });
      lineParent.data.SupplierReceivedQty = totalBatchPickedQty;
      lineData.data.CheckInclude = lineParent.data.CheckInclude;
      if (lineData.data.CheckInclude) {
        // include checked
        if (
          lineParent.data.SupplierReceivedQty >=
          lineParent.data.SupplierOutstandingQuantity
        ) {
          lineParent.data.Completed = true;
        } else {
          lineParent.data.Completed = false;
        }
      } else {
        // include is not checked
        lineParent.data.CheckInclude = true;
        if (
          lineData.data.SupplierBatchReceivedQty >=
          lineParent.data.SupplierOutstandingQuantity
        ) {
          lineParent.data.Completed = true;
        } else {
          lineParent.data.Completed = false;
        }
      }

      if (
        lineData.data.SupplierBatchReceivedQty >
        lineParent.data.SupplierReceivedQty
      ) {
        // let errorMsg = {
        //   Code: lineParent.data.ItemCode,
        //   Description: lineParent.data.ItemDescription,
        //   Batch: lineData.data.BatchNo,
        //   ReturnQty: e.value,
        //   AvailableQty: lineData.data.SupplierAvailableQty,
        // };
        // const index = this.brokenGridValidations.findIndex(
        //   (x) =>
        //     x.Code === lineParent.data.ItemCode &&
        //     x.Batch === lineData.data.BatchNo
        // );
        // if (index > -1) {
        //   this.brokenGridValidations[index] = errorMsg;
        // } else {
        //   this.brokenGridValidations.push(errorMsg);
        // }

        this.$nextTick(function () {
          alert(
            `Item : ${
              lineParent.data.ItemDescription
            } has a received quantity of ${formatNumber(
              e.value
            )} which is more than the outstanding quantity of ${formatNumber(
              lineParent.data.SupplierReceivedQty
            )}.`,
            "Validation Errors"
          );
        });
      } else {
        // const index = this.brokenGridValidations.findIndex(
        //   (x) =>
        //     x.Code === lineParent.data.ItemCode &&
        //     x.Batch === lineData.data.BatchNo
        // );
        // if (index > -1) {
        //   this.brokenGridValidations.splice(index, 1);
        // }
      }

      // if (totalBatchPickedQty > 0) lineParent.data.CheckInclude = true;
      // else {
      //   lineParent.data.CheckInclude = false;
      // }

      if (grid != "grid") {
        var gridItems = grid.getDataSource().items();

        lineParent.data.ExFXTotal = (
          lineParent.data.SupplierReceivedQty * lineParent.data.SupplierFXPrice
        ).toFixed(2);

        if (lineParent.data.TaxPcnt != 0) {
          lineParent.data.TaxFXTotal = (
            lineParent.data.ExFXTotal *
            (1 / lineParent.data.TaxPcnt)
          ).toFixed(2);

          lineParent.data.IncTaxFXTotal =
            parseFloat(
              lineParent.data.SupplierReceivedQty *
                lineParent.data.SupplierFXPrice
            ) +
            parseFloat(
              lineParent.data.ExFXTotal * (1 / lineParent.data.TaxPcnt)
            );
        } else {
          lineParent.data.TaxFXTotal = 0;

          lineParent.data.IncTaxFXTotal = parseFloat(
            lineParent.data.SupplierReceivedQty *
              lineParent.data.SupplierFXPrice
          );
        }

        let includeItems = gridItems.filter((x) => x.CheckInclude);
        let completeItems = includeItems.filter((x) => x.Completed);

        if (includeItems.length == completeItems.length)
          this.disableCompleteHeader(true);
        else this.disableCompleteHeader(false);
      }

      this.updateHeaderCheckBox(items);
    },

    onSupplierReceivedQtyChange(e, lineData, gridItems) {
      if (e.value > lineData.data.SupplierOutstandingQuantity) {
        this.$nextTick(function () {
          alert(
            `Item : ${
              lineData.data.ItemDescription
            } has a received quantity of ${formatNumber(
              e.value
            )} which is more than the outstanding quantity of ${formatNumber(
              lineData.data.SupplierOutstandingQuantity
            )}.`,
            "Validation Errors"
          );
        });
      }
      if (e.component) {
        e.component.beginUpdate();
        e.component.option("value", e.value);
        e.component.endUpdate();
      }

      this.updateHeaderCheckBox(gridItems);
    },

    updateHeaderCheckBox(gridItems) {
      let count = 0;
      gridItems.forEach((element) => {
        if (element.CheckInclude) count = count + 1;
      });

      setTimeout(() => {
        var value = false;
        if (count > 0 && count != gridItems.length) {
          value = undefined;
        } else if (count == 0) {
          value = false;
          this.disableCompleteHeader(true);
        } else if (count == gridItems.length) {
          value = true;
        }

        this.$refs["goods-in"].$refs["transactionGrid"].updateHeaderCheckBox(
          "CheckInclude",
          value
        );
        this.$refs["goods-in"].$refs["transactionGrid"].gridRepaint();
      }, 100);

      this.updateCompleteColumnCheckBox(gridItems);
    },

    updateCompleteColumnCheckBox(gridItems) {
      let count = 0;
      gridItems.forEach((element) => {
        if (element.Completed) count = count + 1;
      });

      setTimeout(() => {
        var value = false;
        if (count > 0 && count != gridItems.length) {
          value = undefined;
        } else if (count == 0) {
          value = false;
        } else if (count == gridItems.length) {
          value = true;
        }

        this.$refs["goods-in"].$refs["transactionGrid"].updateHeaderCheckBox(
          "Completed",
          value
        );
        this.$refs["goods-in"].$refs["transactionGrid"].gridRepaint();
      }, 100);
    },

    disableCompleteHeader(value) {
      this.$refs["goods-in"].$refs["transactionGrid"].disableHeaderCheckBox(
        "Completed",
        value
      );
    },
    checkCompleteHeaderCheckStatus(e) {
      var gridItems = e.component.getDataSource().items();
      let CheckIncludeItems = gridItems.filter((x) => x.CheckInclude);

      if (CheckIncludeItems.length == 0) return true;
      else return false;
    },

    async saveGoodsIn(dataModel, gridItems) {
      let manualBatchValidation = true;
      let manufacturedDateRequire = false;
      let payload = {
        DateIn: dataModel.DateIn
          ? dataModel.DateIn.toSaveDate()
          : dataModel.DateIn,
        DateReceived: dataModel.DateReceived
          ? dataModel.DateReceived.toSaveDate()
          : dataModel.DateReceived,
        SupplierCode: dataModel.SupplierCode,
        GoodsInDetails: [],
        DateChanged: dataModel.DateChanged
          ? new Date(dataModel.DateChanged).toISOString().replace("Z", "")
          : null,
      };

      gridItems.forEach((el) => {
        if (el.CheckInclude) {
          let obj = {
            ActualStockConversion: el.SupplierConversion,
            Comment: el.GoodsInDetailComment,
            IsVariable: el.IsVariable,
            ItemCode: el.ItemCode,
            LineComplete: el.Completed ? "Y" : "N",
            PurchaseOrderCode: el.PurchaseOrderCode,
            PurchaseOrderComment: el.Comment,
            PurchaseOrderLineNo: el.LineNo,
            ReceivedQty: el.SupplierReceivedQty * el.SupplierConversion,
            StandardStockConversion: el.SupplierConversion,
            SupplierReceivedQty: el.SupplierReceivedQty,
            GoodsInProductBatches: [],
          };

          if (el.ChildDataSource) {
            el.ChildDataSource.forEach((i) => {
              let objBatch = {
                ActualStockConversion: i.ActualStockConversion,
                BatchNo: i.BatchNo,
                Comment: el.GoodsInDetailComment,
                ReceivedQty:
                  i.SupplierBatchReceivedQty * i.ActualStockConversion,
                SupplierBatchNo: i.SupplierBatchNo,
                SupplierReceivedQty: i.SupplierBatchReceivedQty,
                UseByDate: i.UseByDate ? i.UseByDate.toSaveDate() : i.UseByDate,
                BestBeforeDate: i.BestBeforeDate
                  ? i.BestBeforeDate.toSaveDate()
                  : i.BestBeforeDate,
                ManufacturedDate: i.ManufacturedDate
                  ? i.ManufacturedDate.toSaveDate()
                  : i.ManufacturedDate,
              };
              obj.GoodsInProductBatches.push(objBatch);
            });
          } else {
            delete obj.GoodsInProductBatches;
          }

          if (el.IsBatchProduct == "Manual") {
            el.ChildDataSource.forEach((batch) => {
              if (!batch.BatchNo && batch.SupplierBatchReceivedQty != 0)
                manualBatchValidation = false;

              if (
                batch.SupplierBatchReceivedQty != 0 &&
                batch.IsManufacturedDateRequired == "Y" &&
                !batch.ManufacturedDate
              ) {
                manufacturedDateRequire = true;
              }
            });
          }
          payload.GoodsInDetails.push(obj);
        }
      });

      // let nonZeroQtys = payload.GoodsInDetails.findIndex(
      //   (item) => item.CheckInclude == true
      // );
      // console.log("ccccccccccccccccccccccccc", gridItems);
      // return;

      if (payload.GoodsInDetails.length == 0) {
        this.validationSummary = [];
        this.validationSummary.push({
          message: "You must have at least one line received.",
        });
        return;
      }

      if (manualBatchValidation && !manufacturedDateRequire) {
        this.setLoading = true;
        await GoodsInService.saveGoodsIn(payload)
          .then((res) => {
            this.setLoading = false;
            this.$notify(
              `Successfully created Goods In ${res.data.Code}`,
              "success"
            );

            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: `/goods-in`,
            });

            this.$logger.debug("response", res);
          })
          .catch((error) => {
            this.setLoading = false;
            this.serverError = {
              err: error,
              msg: "Goods In save failed",
              time: new Date().getTime(),
            };
          });
      } else {
        this.validationSummary = [];
        let error = [];

        if (manufacturedDateRequire)
          error.push({ message: "Manufactured Date is Required" });

        if (!manualBatchValidation)
          error.push({
            message:
              "Batch Numbers are required for products that have a Manual batch method.",
          });
        this.validationSummary = error;
      }
    },
    async setActiveAccountingPeriod() {
      let startDateResult =
        await GoodsInService.getActiveAccountingPeriodStartDate();
      if (startDateResult) {
        let accountingPeriod = startDateResult.data.value[0];
        this.ui.DateInMin = new Date(accountingPeriod.StartDate);
      }
      let endDateResult =
        await GoodsInService.getActiveAccountingPeriodEndDate();
      if (endDateResult) {
        let accountingPeriod = endDateResult.data.value[0];
        this.ui.DateInMax = new Date(accountingPeriod.EndDate);
      }
    },
    async initialized() {
      // await this.$store.dispatch(
      //   "defaultCustomerSettings/setCustomerById",
      //   this.baseView.id
      // );
      // await this.$store.dispatch(
      //   "defaultUserSettings/setDefaultCompanyBranchDivision"
      // );

      this.loaded = true;
    },
    async cashReceiptPostProcess(data) {
      if (data.Customer) {
        data.CustomerName = data.Customer.Name;
      }
      return data;
    },
    PostProcess(data) {
      data.forEach((element, index) => {
        element.ID = index;
        element["ExFXTotal"] = 0;
        element["TaxFXTotal"] = 0;
        element["IncTaxFXTotal"] = 0;
        element["GoodsInComment"] = element["Comment"];
        if (element["PurchaseDescription"])
          element["ItemDescription"] = element["PurchaseDescription"];
        if (element.IsBatchProduct == "No") {
          // Not Batched
          element["CheckInclude"] = false;
          element["SupplierReceivedQty"] = 0;
          element["Completed"] = false;
        } else {
          this.IsBatchAvailable = true;
          // Batched
          if (
            element.IsBatchProduct == "NextNo" ||
            element.IsBatchProduct == "Auto"
          ) {
            element["ChildDataSource"] = [
              {
                BatchNo: "System Generated",
                SupplierBatchNo: "",
                SupplierCode: "",
                UseByDate: null,
                SupplierBatchReceivedQty: 0,
                ActualStockConversion: element.SupplierConversion,
                ReceivedQty: 0, // element.ReceivedQty,
                SupplierOutstandingQuantity:
                  element.SupplierOutstandingQuantity,
                IsManufacturedDateRequired: element.IsManufacturedDateRequired,
                UseByShelfLife: element.UseByShelfLife,
                BestBeforeShelfLife: element.BestBeforeShelfLife,
                IsBatchProduct: element.IsBatchProduct,
                BestBeforeDate: undefined,
                ManufacturedDate: undefined,
              },
            ];
          } else {
            if (element.IsBatchProduct == "Manual") {
              // element["GoodsInProductBatches"] = [];
              element["ChildDataSource"] = [
                {
                  BatchNo: "",
                  SupplierBatchNo: "",
                  SupplierCode: "",
                  UseByDate: null,
                  SupplierBatchReceivedQty: 0,
                  ActualStockConversion: element.SupplierConversion,
                  ReceivedQty: 0, // element.ReceivedQty,
                  SupplierOutstandingQuantity:
                    element.SupplierOutstandingQuantity,
                  IsManufacturedDateRequired:
                    element.IsManufacturedDateRequired,
                  UseByShelfLife: element.UseByShelfLife,
                  BestBeforeShelfLife: element.BestBeforeShelfLife,
                  IsBatchProduct: element.IsBatchProduct,
                  BestBeforeDate: undefined,
                  ManufacturedDate: undefined,
                },
              ];
            } else {
              element["SupplierReceivedQty"] =
                element["SupplierOutstandingQuantity"];
            }
          }
          element["CheckInclude"] = false;
          element["SupplierReceivedQty"] = 0;
          element["Completed"] = false;
        }
      });

      this.updateHeaderCheckBox(data);
      return data;
    },
  },
  watch: {
    IsBatchAvailable: {
      handler(val) {
        if (val && this.CollapseBtnContentReady) {
          this.CollapseBtnContentReady.component.beginUpdate();
          this.CollapseBtnContentReady.component.option("visible", true);
          this.CollapseBtnContentReady.component.endUpdate();
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.goods-in {
  .gc-form-header-toolbar {
    padding-bottom: 0px !important;
  }

  .dx-datebox input.dx-texteditor-input {
    font-size: 12px !important;
  }
}

.css-v2
  .dx-datagrid.dx-gridbase-container
  .dx-datagrid-rowsview
  .dx-row.dx-data-row
  .dx-editor-cell.gc-num-input
  input.dx-texteditor-input {
  height: unset !important;
  min-height: 20px !important;
}
</style>
